import React from 'react';
import { connect } from 'react-redux';
import ViewAllGroupContent from '../components/pages/group/view-all/content';

function GroupPage(props) {
  return <ViewAllGroupContent />;
}

export default GroupPage;
